export enum IconVariant {
  Default = 'default',
  Circle = 'circle',
  CircleFilled = 'circleFilled',
  HexagonFilled = 'hexagonFilled',
  TriangleFilled = 'triangleFilled',
}
